// Recorrido de la lista de Casos: los folios en el orden VISUAL en que se
// mostraron (respeta filtros, orden y agrupado), para que el detalle del
// caso ofrezca «‹ Anterior · N de M · Siguiente ›» sin regresar a la lista.
// Vive en sessionStorage: sobrevive un F5 y muere al cerrar la pestaña.
// Un caso abierto por link directo (alerta, TE, Telegram) puede no estar
// en el recorrido — en ese caso el detalle simplemente no muestra flechas.
const KEY = "arktickets-recorrido-casos";

export function guardarRecorrido(folios: string[]) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(folios));
  } catch {
    // sessionStorage lleno o bloqueado — el navegador de casos no aparece.
  }
}

export function leerRecorrido(): string[] {
  try {
    const raw = sessionStorage.getItem(KEY);
    const lista = raw ? (JSON.parse(raw) as unknown) : [];
    return Array.isArray(lista) ? lista.filter((f) => typeof f === "string") : [];
  } catch {
    return [];
  }
}
